export const institutionConstants = {
  GET_INSTITUTIONS: "GET_INSTITUTIONS",
  GET_INSTITUTION: "GET_INSTITUTION",
  GET_PRISES_CHARGES: "GET_PRISES_CHARGES",
};
